const configConstants = {
  CONFIG_REQUEST: 'CONFIG_REQUEST',
  CONFIG_SUCCESS: 'CONFIG_SUCCESS',
  CONFIG_FAILURE: 'CONFIG_FAILURE',

  CONFIG_SETUP_REQUEST: 'CONFIG_SETUP_REQUEST',
  CONFIG_SETUP_SUCCESS: 'CONFIG_SETUP_SUCCESS',
  CONFIG_SETUP_FAILURE: 'CONFIG_SETUP_FAILURE',

  CONFIG_UPD_REQUEST: 'CONFIG_UPD_REQUEST',
  CONFIG_UPD_SUCCESS: 'CONFIG_UPD_SUCCESS',
  CONFIG_UPD_FAILURE: 'CONFIG_UPD_FAILURE',

  CONFIG_VAL_REQUEST: 'CONFIG_VAL_REQUEST',
  CONFIG_VAL_SUCCESS: 'CONFIG_VAL_SUCCESS',
  CONFIG_VAL_FAILURE: 'CONFIG_VAL_FAILURE',
};

export default configConstants;
